import CampaignsPage from './CampaignsPage';

export default CampaignsPage;
